import { slide as Menu } from 'react-burger-menu';
import logo from './mainLogo.png';
import { useNavigate } from 'react-router-dom';



const BurgerSlideMenu = ({ isOpen, setIsOpen }) => {
  const handleStateChange = ({ isOpen }) => {
    setIsOpen(isOpen);
    document.body.classList.toggle('menu-open', isOpen);
  };


  const navigate = useNavigate()

  return (
    <Menu
      isOpen={isOpen}
      onStateChange={handleStateChange}
      width={'80%'}
      customBurgerIcon={false}
      left={true}
    >
      <div className="bm-header">
          {/* Logo for the Burger Menu*/}
          <img src={logo} className="logo-burgerMenu" id="logo_og" onClick={() => {navigate('/'); setIsOpen(false);}} alt="logo" />
      </div>

      <div className="bm-items">
        <a className="bm-item" href="/dogwalkers">Dog Walkers</a>
        <a className="bm-item" href="/contact">Contact</a>
        <a className="bm-item" href="/faq">FAQ</a>
      </div>

    </Menu>
  );
};

export default BurgerSlideMenu;